import React from 'react';
import CheckSignStatus from '../../user/CheckSignStatus';

const MainContentArea = (props)=>{
    
    return(
        <div className='uiAppPaper'>
            <div className="uiAppContent">
                <CheckSignStatus />
                {props.children}
            </div>
        </div>
    );

}

export default MainContentArea